<template>
  <div :key="key" class="dashboard-chart">
    <h4 class="titulo">Ventas</h4>
    <!-- <h4 :class="totalNegocio ? 'titulo' : ''">Ventas</h4>  -->
    <p v-if="!totalNegocio" class="subtitulo">No incluye reembolsos</p>
    <vue-svg-gauge
      :start-angle="-110"
      :end-angle="110"
      :value="indicadorVentasActualDisplay"
      :separator-step="indicadorVentasObjetivoDisplay"
      :min="indicadorVentasMin"
      :max="indicadorVentasMax"
      :gauge-color="indicadorVentasColor"
      :scale-interval="10">
      <!-- <div class="inner-text">
        <p>Importe Objetivo {{ indicadorVentasObjetivo | moneda }}</p>
        <p>Importe Actual {{ indicadorVentasActual | moneda }}</p>
      </div> -->
    </vue-svg-gauge>

    <chart-avance ref="avance" :pjeAvance="indicadorPjeAvancePeriodo" />

    <div class="dashboard-chart-text">
      <p>Obj. Estimado: {{ indicadorVentasObjetivo | moneda }}</p>
      <p>Actual: {{ indicadorVentasActual | moneda }}</p>
      <p>Actual Anual: {{ indicadorVentasAnual | moneda }}</p>
      <p>Pje. Actual: {{ indicadorVentasPjeActual | numero(2, true) }} %</p>
      <p class="description">{{ indicadorVentasDescripcion }}</p>
      <p v-if="verDatosVentas" 
        class="link" 
        @click.stop="exportarVentasComprobantes"><i class="fa fa-file-excel-o"></i>Exportar Comprobantes</p>
      <p v-if="verVentasExcluidas" 
        class="link" 
        @click.stop="exportarVentasComprobantesExcluidos"><i class="fa fa-file-excel-o"></i>Exportar Compr. Excluidos</p>
      <p v-if="accesoActualizar"
        class="link"
        @click.stop="actualizarMontoVentas"><i class="fa fa-undo"></i>Actualizar Resultados</p>
    </div>
  </div>
</template>

<script>
import { VueSvgGauge } from 'vue-svg-gauge';
import ChartAvance from './ChartAvance.vue';

export default {
  components: {
    VueSvgGauge,
    ChartAvance
  },
  props: {
    totalNegocio: {
      type: Boolean,
      default: false
    },
    accesoActualizar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rojo: '#E46651',
      verde: '#41B883',
      amarillo: '#FAFA05',
      rosa: '#FF0187',

      key: 0,
      indicadorVentasObjetivo: 0,
      indicadorVentasActual: 0,
      indicadorVentasAnual: 0,
      indicadorVentasObjetivoDisplay: parseInt(0), /*  0, */
      indicadorVentasActualDisplay: 0,
      indicadorVentasColor: [{ offset: 0, color: '#E46651' }, { offset: 100, color: '#E46651' }],
      // indicadorVentasColor: [{ offset: 0, color: '#E46651' }, { offset: 100, color: '#41B883' }],
      indicadorVentasMin: 0,
      indicadorVentasMax: 100,
      indicadorVentasPjeActual: 0,
      indicadorVentasDescripcion: '',
      indicadorPjeAvancePeriodo: 0,

      verDatosVentas: false,
      verVentasExcluidas: false,
    }
  },
  created() {
    this.verDatosVentas = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardIndicadorVentasConsultarVentas'));
    this.verVentasExcluidas = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardIndicadorVentasConsultarVentasExcluidas'));
  },
  methods: {
    getIndicador() {
      let dispatch = 'resultadosVentas/getIndicadorVentas';
      let getter = 'resultadosVentas/indicadorVentas';

      if ( (/true/i).test(this.totalNegocio)) {
        dispatch = 'resultadosVentas/getIndicadorVentasTotal';
        getter = 'resultadosVentas/indicadorVentasTotal';
      }

      this.$store.dispatch(dispatch)
        .then(() => {
          let indicador = this.$store.getters[getter]

          this.indicadorVentasObjetivo = indicador.montoObjetivo;
          this.indicadorVentasActual =  indicador.montoActual;
          this.indicadorVentasAnual = indicador.montoAnual;
          
          this.indicadorVentasActualDisplay = parseFloat(indicador.pjeActualObjetivo);
          if (parseFloat(indicador.pjeActualObjetivo) > parseFloat(100)) {
            this.indicadorVentasActualDisplay = parseFloat(100);
          }
          
          this.indicadorVentasMin = 0;
          this.indicadorVentasMax = 100; /* parseFloat(indicador.montoObjetivo / 100000); */ /* 100000; */
          this.indicadorVentasPjeActual = parseFloat(indicador.pjeActualObjetivo);
          this.indicadorVentasDescripcion = indicador.indicadorPeriodo;
          // this.indicadorVentasDescripcion = indicador.descripcion;

          // if (parseFloat(indicador.pjeActualObjetivo) >= parseFloat(110)) {
          //   this.indicadorVentasColor = [{ offset: 0, color: this.rosa }, { offset: 100, color: this.rosa }];
          // } else 
          if (parseFloat(indicador.pjeActualObjetivo) >= parseFloat(100)) {
            this.indicadorVentasColor = [{ offset: 0, color: this.verde }, { offset: 100, color: this.verde }];
          } else if (parseFloat(indicador.pjeActualObjetivo) > parseFloat(50)) {
            this.indicadorVentasColor = [{ offset: 0, color: this.amarillo }, { offset: 100, color: this.amarillo }];
          }

          this.indicadorPjeAvancePeriodo = indicador.pjeAvancePeriodo;
        })
        .finally(() => this.key++);
    },
    cancelar() {
      this.$store.dispatch('resultadosVentas/cancelar');
    },
    exportarVentasComprobantesExcluidos() {
      this.showSpinner();
      this.$store.dispatch('resultadosVentas/getIndicadorVentasComprobantesExcluidos')
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptComprobantes = this.$store.getters['resultadosVentas/resultados'];

          if (rptComprobantes) {
            if (rptComprobantes.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Detalle de Ventas Excluidas';
            let fileName = 'ventas-excluidas';
            let format = [
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total', nombre: 'total', formato: '' }
            ];

            this.exportXLS(title, fileName, rptComprobantes, format);
          } else {
            console.log('No hay datos para exportar.');
          }
        })
        .catch(error => {
          console.log(error);
          // this.showErrorMsj(error)
        })
        .finally(() => this.hideSpinner());
    },
    exportarVentasComprobantes() {
      this.showSpinner();
      this.$store.dispatch('resultadosVentas/getIndicadorVentasComprobantes')
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptComprobantes = this.$store.getters['resultadosVentas/resultados'];

          if (rptComprobantes) {
            if (rptComprobantes.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Detalle de Ventas';
            let fileName = 'ventas';
            let format = [
              { titulo: 'Fecha Comprobante', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Fecha Imputación', nombre: 'fechaImputacionIndicadores', formato: 'fecha' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Numero', nombre: 'numero', formato: '' },
              { titulo: 'Monto Total', nombre: 'montoTotal', formato: '' },
              { titulo: 'Monto Neto', nombre: 'montoNeto', formato: '' },
              // { titulo: 'Neto S/Reembolsos', nombre: 'montoNetoSinReembolsos', formato: '' },
              { titulo: 'Neto Reembolsos', nombre: 'montoNetoReembolsos', formato: '' },
              { titulo: 'Presupuestos', nombre: 'presupuestosInternos', formato: '' }
            ];

            this.exportXLS(title, fileName, rptComprobantes, format);
          } else {
            console.log('No hay datos para exportar.');
          }
        })
        .catch(error => {
          console.log(error);
          // this.showErrorMsj(error)
        })
        .finally(() => this.hideSpinner());
    },
    actualizarMontoVentas() {
      this.showSpinner();
      this.$store.dispatch('resultadosVentas/actualizarMontoVentasReembolsos')
        .then(() => this.getIndicador())
        .catch(error => console.dir(error))
        .finally(() => this.hideSpinner());      
    }

  }
}
</script>

<style>
</style>


